export interface ICarerSwitch {
  endDate?: Date | null;
  beginDate?: Date | null;
  note?: string | null;
}

export class CarerSwitch implements ICarerSwitch {
  constructor(public endDate?: Date | null, public note?: string | null) {}
}
